module.exports = __webpack_public_path__ + "static/media/maps.77d272e1.png";